















import { mapActions } from 'vuex'
import { navigateTo } from '@/router'
import PublicPageContainer from '@/components/PublicPageContainer.vue'
import PublicPageContent from '@/components/PublicPageContent.vue'

const _30_SECONDS = 30000

export default {
  components: { PublicPageContent, PublicPageContainer },
  created() {
    this.checkInterval = setInterval(this.checkBackend, _30_SECONDS)
  },
  beforeDestroy() {
    clearInterval(this.checkInterval)
  },
  methods: {
    ...mapActions(['checkBackendHealth']),
    async checkBackend() {
      try {
        await this.checkBackendHealth()
        navigateTo('/')
      } catch (error) {
        // The backend is still down and we should stay on the error page
      }
    }
  }
}
